import Vue from 'vue';
import { getTrans } from 'tools/getFromHtml';

export default Vue.component('SelectSearchSorting', {
    props: {
        disabled: {
            type: Boolean,
            required: false,
        },
        inputRole: {
            type: String,
            required: true,
        },
        inputData: {
            type: Array,
            required: true,
        },
        selectedKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            active: '',
        };
    },
    methods: {
        changeInput(event) {
            this.$parent.selectedSorting = event.currentTarget.value;
        },
        trans(text) {
            return getTrans(text) ? getTrans(text) : text;
        },
    },
    template: `
        <div class="flex--grow">
            <select 
                v-if="inputRole == 'master'" 
                id="sortMethod" 
                name="sortMethod" 
                class="margin-left-10" 
                :value="selectedKey" 
                @change="changeInput" 
                :disabled="disabled">
                <option 
                    v-for="item in inputData" 
                    :value="item.value" 
                    :selected="selectedKey == item.value ? 'selected' : ''">{{ trans(item.label) }}
                </option>
            </select>
            <div 
                v-if="inputRole == 'slave'" 
                id="sortMethodMobile" 
                class="mobileRadioGroup mobileRadioGroup--fullWidth margin-bottom-20 flex--wrap">
                <label 
                    v-for="item in inputData" 
                    class="mobileRadioGroup__item">
                    <input 
                        type="radio" 
                        :value="item.value" 
                        :data-gtm_SearchFilterSort="'mobile'+item.value" 
                        name="sortMethodMobile" 
                        class="mobileRadioGroup__input" 
                        :checked="selectedKey == item.value ? 'checked' : ''" 
                        @change="changeInput" 
                        :disabled="disabled" />
                    <span class="mobileRadioGroup__text padding-vertical-7">{{ trans(item.label) }}</span>
                </label>
            </div>
        </div>
    `,
});
